/*
 *
 * Entry point for rchat plugin javascripts.
 *
 */
import React from 'react'
import ReactDOM from 'react-dom'
import domready from 'domready'

import {UI_SELECTOR, UI_CLASS} from './shared/config/constants'

import ChatUI from './chat_ui'

import {
  initDataForUI,
  initSettings
} from './shared/data/init'

const loadUI = () => {
  domready(() => {
    let uiElement = document.querySelector(UI_SELECTOR)

    if (uiElement) {
      if(uiElement.className.length > 0) uiElement.className += ' '
      uiElement.className += UI_CLASS

      ReactDOM.render(<ChatUI />, uiElement)
    }
  })
}

initDataForUI()
initSettings(rchat._conf)
loadUI()



/** WEBPACK FOOTER **
 ** ./modules/rchat.ui.js
 **/